import { Injectable } from "@angular/core";
import { API_ENDPOINT, ROUTER_CONFIG } from "@core/configs";
import { HttpClient, HttpHeaders, HttpStatusCode } from "@angular/common/http";
import { catchError, map } from "rxjs/operators";
import { NEVER } from "rxjs";
import { Router } from "@angular/router";

@Injectable({
  providedIn: 'root',
})
export class ResourcePolicyService {
  constructor(private readonly http: HttpClient, private readonly router: Router) {}

  checkResourcePolicy() {
    return this.http.get<any>(API_ENDPOINT.authConsole.checkResourcePolicy, {
      headers: new HttpHeaders(
        {
          // eslint-disable-next-line @typescript-eslint/naming-convention
          'content-type': 'application/json',
          // eslint-disable-next-line quote-props
          // eslint-disable-next-line @typescript-eslint/naming-convention
          'x-requested-with': 'XMLHttpRequest',
          // eslint-disable-next-line @typescript-eslint/naming-convention
          'access-control-allow-origin': '*',
        },
      ),
      observe: 'response',
    }).pipe(
      map((res) => {
        return res;
      }),
      catchError((error) => {
        if (Number(error.status) === HttpStatusCode.Forbidden || Number(error.status) === 0) {
          this.router.navigate([ROUTER_CONFIG.forbidden], { skipLocationChange: true });
        }
        return NEVER;
      }),
    );
  }
}